import StorageService from '@/api/Storage';

const daysWithoutMfaSetupAllowed = 5;

const authorization = {
  state: {
    user: null,
    showSiteLoader: true,
    mfaResponse: {},
    tokensUpdated: null,
    showTestFixture: null,
  },
  mutations: {
    setTokens(state, response) {
      state.tokensUpdated = new Date();
      if (response && response.access) {
        StorageService.setItem('accessToken', response.access);
      }

      if (response && response.refresh) {
        StorageService.setItem('refreshToken', response.refresh);
      }
    },
    setUser(state, user) {
      state.user = user || null;

      if (state.user) {
        this.dispatch('userLoggedIn');
      } else {
        this.dispatch('userLoggedOut');
      }
    },
    setShowSiteLoader(state, show) {
      state.showSiteLoader = show;
    },
    setUserMfa(state, mfaResponse) {
      state.mfaResponse = mfaResponse;
    },
    setShowTestFixture(state, showTestFixture) {
      state.showTestFixture = showTestFixture;
    },
  },
  actions: {
    clearUser(store) {
      store.commit('setTokens', null);
      store.commit('setUser', null);
      store.commit('setUserMfa', null);
      store.commit('setShowTestFixture', null);
      StorageService.removeItem('accessToken');
      StorageService.removeItem('refreshToken');
    },
    loadedRemoteUser(store) {
      store.commit('setShowSiteLoader', false);
    },
    userLoggedIn() {
    },
    userLoggedOut() {
    },
  },
  getters: {
    currentUser(state) {
      return state.user || {};
    },
    isKgbAdminUser(state) {
      return state.user
        && (state.user.is_admin);
    },
    isOrgAdminAccess(state) {
      return state.user
        && (state.user.is_admin || state.user.is_organization_admin);
    },
    isAdminUser(state) {
      return state.user
        && (state.user.is_admin || state.user.is_organization_admin || state.user.is_site_admin);
    },
    isAuthorized(state) {
      return !!state.user;
    },
    showSiteLoader(state) {
      return state.showSiteLoader;
    },
    mfaResponse(state) {
      return state.mfaResponse || {};
    },
    mfaIsRequired(state) {
      return state
        && state.user
        && state.mfaResponse
        && state.mfaResponse.count === 0
        && state.user.loginsWithoutMfa > daysWithoutMfaSetupAllowed;
    },
    mfaWarning(state) {
      return {
        show: state
          && state.user
          && state.mfaResponse
          && state.mfaResponse.count === 0
          && state.user.loginsWithoutMfa <= daysWithoutMfaSetupAllowed,
        daysRemaining: (state.user)
          ? daysWithoutMfaSetupAllowed - state.user.loginsWithoutMfa + 1
          : 0,
      };
    },
    showTestFixture(state) {
      return state && state.showTestFixture && state.showTestFixture.displayTestFixture;
    },
    tokensUpdated(state) {
      return state.tokensUpdated;
    },
  },
};

export default authorization;
